import React, { Component } from 'react';
import styled, { css } from 'react-emotion';
import withDirection from '~/modules/core/utils/mediaHelpers/withDirection';
import ItemsListFilter from './ItemsListFilter';

const Icon = styled.i`
  color: ${props => props.theme.colors.primary};
  font-size: ${props => props.theme.fonts.sizes.xxLarge - 4}px;
  cursor: pointer;
`;
const ItemsListFilterStyle = styled(ItemsListFilter)`
  position: absolute;
  width: 100% !important;
`;
const FilterDropdownWrapper = styled.div`
  position: relative;
`;
const FilterWrapper = withDirection(styled.div`
  > div {
    width: ${props => props.theme.paddings.xxxLarge * 10 - 9}px;
    position: absolute;
    top: ${props => props.theme.paddings.xxxxxLarge}px;
    ${props => (props.direction === 'rtl'
    ? css`
        right: 0;
        text-align: right;
      `
    : css`
        left: 0;
        text-align: left;
      `
  )}
    z-index: 2;
    box-shadow: 0px 5px 10px 0 rgba(0, 0, 0, 0.05);
    background: ${props => props.theme.colors.named.white};
  }
  &:after {
    position: absolute;
    top: ${props => props.theme.paddings.xxxxLarge + 1}px;
    ${props => (props.direction === 'rtl'
    ? css`
        left: ${props.theme.paddings.medium}px;
      `
    : css`
        right: ${props.theme.paddings.medium}px;
      `
  )}
    background: ${props => props.theme.colors.named.white};
    width: ${props => props.theme.paddings.medium}px;
    height: ${props => props.theme.paddings.medium}px;
    border-top: solid ${props => props.theme.borders.size.thin}px
      ${props => props.theme.borders.color.light};
    border-right: solid ${props => props.theme.borders.size.thin}px
      ${props => props.theme.borders.color.light};
    content: '';
    transform: rotate(-45deg);
    z-index: 3;
  }
`);
export default class FilterDropdown extends Component {
  state = {
    showFilter: false,
  };

  toggleFilter = () => {
    this.setState(prevState => ({
      showFilter: !prevState.showFilter,
    }));
  };

  render() {
    return (
      <FilterDropdownWrapper>
        <Icon
          className={this.state.showFilter ? 'el-icon el-icon-filter-filled' : 'icon-filter'}
          onClick={this.toggleFilter}
        />
        {this.state.showFilter && (
          <FilterWrapper>
            <ItemsListFilterStyle showFilterDropdown />
          </FilterWrapper>
        )}
      </FilterDropdownWrapper>
    );
  }
}
